import { Button, Form, Input } from 'antd'
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { RouteChildrenProps } from "react-router"
import { AutoRedirectAfterSubmitSuccessfully } from '../../../../constants/constants'
import { ROUTE_PATHS } from "../../../../constants/url-config"
import { MessageType } from '../../../../models/common/response-message'
import { AuthService } from '../../../../services/auth.service'
import { showMessage } from '../../../atoms/notification/notification'
import "./forgot-password.scss"

interface Props extends RouteChildrenProps { }

export default function ForgotPassword(props: Props) {

	const { t } = useTranslation();
	const [submited, setSubmited] = useState(false);

	const handleSubmit = async (value: any) => {

		AuthService.forgotPassword(value.email).then(() => {
			showMessage({ message: t("ForgotPassword.messageSendEmailResetPassword"), type: MessageType.success });
			setSubmited(true);
			setTimeout(() => {
				props.history.push(ROUTE_PATHS.Home);
			}, AutoRedirectAfterSubmitSuccessfully)
		});
	}

	return (
		<div className="forgot-form">
			<div className='header'>
				<p className='big-title'>
					{t('ForgotPassword.title')}
				</p>
				<p className='description-text'>
					{t('ForgotPassword.welcome')}
				</p>
			</div>
			<Form
				name='forgot'
				layout="vertical"
				onFinish={handleSubmit}
			>
				<Form.Item
					label={t('ForgotPassword.email')}
					name='email'
					rules={[
						{ required: true, message: t('ForgotPassword.emailRequired') },
						{ type: 'email', message: t('ForgotPassword.emailInvalid') },
					]}
				>
					<Input />
				</Form.Item>

				<Form.Item >
					<Button htmlType='submit' type="primary" shape="round" disabled={submited}>
						{t('ForgotPassword.continue')}
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}
